module.exports = __webpack_public_path__ + "img/RAC.6589a15e.png";